import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppMainComponent } from 'src/app/app.main.component';
import { Fournisseur } from 'src/app/entites/fournisseur';
import { Emplacement } from 'src/app/entites/emplacement';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { EvaluationFournisseur } from 'src/app/entites/evaluation-fournisseur';

@Component({
  templateUrl: 'evaluation-fournisseur.component.html',
  styleUrls: ['evaluation-fournisseur.component.scss'],
  providers: [MessageService, ConfirmationService, DialogService, ProfilService],
  standalone: false
})

export class EvaluationFournisseurComponent extends BaseComponent implements OnInit {
  submitted = false;
  sent = false;
  fournisseurId: number;
  sousTraitant: boolean;
  emplacements: Emplacement[];
  evaluation: EvaluationFournisseur;

  ratingOptions = [
    { label: 'Mauvais', value: 'mauvais' },
    { label: 'Acceptable', value: 'acceptable' },
    { label: 'Bon', value: 'bon' },
    { label: 'Très bon', value: 'tres_bon' },
    { label: 'N/A', value: 'na' }
  ];

  constructor(
    private fb: FormBuilder,
    protected messageService: MessageService,
    protected confirmationService: ConfirmationService,
    protected dialogService: DialogService,
    protected sdb: DonneesBaseService,
    protected profilService: ProfilService,
    protected route: ActivatedRoute,
    protected routerService: Router,
    public appMain: AppMainComponent,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private fournisseurService: FournisseurService
  ) {
    super(sdb, profilService, route, routerService, appMain);
  }



  ngOnInit() {
    this.fournisseurId = this.config.data.fournisseurId;
    this.sousTraitant = this.config.data.sousTraitant;
    this.evaluation = JSON.parse(JSON.stringify(this.config.data.evaluation));
    this.evaluation.isRetained = true;
    this.modeAffichage = this.config.data.modeAffichage;

    this.emplacements = this.sdb.EmplacementsComplet();

    if (!this.sousTraitant) {
      ['sstmanagement', 'deadlineRespect', 'workQuality', 'documentQuality', 'workSupervision', 'communication', 'qualityOfWorkers', 'legalCompliance', 'hamelConstructionPolicy', 'safeWorkingPractices', 'dailyAST', 'ppeCompliance', 'sstSupervision', 'sstCollaborationIndice'].forEach(field => {
        this.evaluation[field] = 'na';
      });
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.valider()) {
      this.fournisseurService.AjouterOuModifierEvaluationFournisseur(this.fournisseurId, this.evaluation).subscribe({
        next: (response) => {
          this.sent = true;
          this.ref.close(response.body);
          this.messageService.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'Évaluation enregistrée avec succès'
          });
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: `Une erreur est survenue lors de l'enregistrement de l'évaluation: ${error.message || error}`
          });
        }
      });

    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Veuillez remplir tous les champs obligatoires'
      });
    }
  }

  valider(): boolean {
    if (this.evaluation.isRetained === null
      || !this.evaluation.emplacement
      || !this.evaluation.productsServices
      || !this.evaluation.qualityExpectations
      || !this.evaluation.productAccuracy 
      || !this.evaluation.quantityAccuracy
      || !this.evaluation.correctionSpeed
      || !this.evaluation.deliveryFlexibility
      || !this.evaluation.deliveryDeadlines
      || !this.evaluation.priceResponseTime
      || !this.evaluation.serviceWarranty
      || !this.evaluation.contactQuality
      || !this.evaluation.pricingClarity
      || !this.evaluation.qualityPriceRatio
      || !this.evaluation.paymentPolicy
      || (this.sousTraitant && !this.evaluation.sstmanagement)
      || (this.sousTraitant && !this.evaluation.deadlineRespect)
      || (this.sousTraitant && !this.evaluation.workQuality)
      || (this.sousTraitant && !this.evaluation.documentQuality)
      || (this.sousTraitant && !this.evaluation.workSupervision)
      || (this.sousTraitant && !this.evaluation.communication)
      || (this.sousTraitant && !this.evaluation.safeWorkingPractices)
      || (this.sousTraitant && !this.evaluation.dailyAST)
      || (this.sousTraitant && !this.evaluation.ppeCompliance)
      || (this.sousTraitant && !this.evaluation.sstSupervision)
      || (this.sousTraitant && !this.evaluation.sstCollaborationIndice)
    ) {
      return false;
    }
    return true;
  }


  onCancel() {
    this.ref.close();
  }


}